import React, { useState } from 'react'
import { Button, Input } from 'reactstrap'
import PropTypes from 'prop-types'
import { VoucherService } from 'domains/voucher/services'
import { CardTextData } from 'components'

const propTypes = {
  isEditPage           : PropTypes.bool,
  voucherAttributes    : PropTypes.array,
  setVoucherAttributes : PropTypes.func,
  updatedVoucher       : PropTypes.array,
  setUpdatedVoucher    : PropTypes.func
}

const defaultProps = {
  isEditPage           : false,
  voucherAttributes    : [],
  setVoucherAttributes : () => alert('setVoucherAttributes triggered'),
  updatedVoucher       : [],
  setUpdatedVoucher    : () => alert('setUpdatedVoucher triggered')
}

const VoucherGenerateCodeFields = ({
  isEditPage,
  voucherAttributes,
  setVoucherAttributes,
  updatedVoucher,
  setUpdatedVoucher
}) => {

  const [ voucher, setVoucher ] = useState({
    codeFormat: 'alphanumeric'
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target

    setVoucher((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }


  const generateVoucherCode = () => {
    let voucherBags = []

    const {
      usePerCustomer,
      usageLimit,
      quantity,
      codeLength,
      codeFormat,
      codePrefix,
      codeSuffix,
      dashCount
    } = voucher

    for (let i = 0; i < quantity; i++) {
      const generatedCode = VoucherService.generateCode(
        codeLength,
        codeFormat,
        codePrefix,
        codeSuffix,
        dashCount
      )
      const data          = {
        code             : generatedCode,
        use_per_customer : usePerCustomer,
        usage_limit      : usageLimit
      }
      voucherBags.push(data)
    }

    isEditPage
      ? setUpdatedVoucher([ ...updatedVoucher, ...voucherBags ])
      : setVoucherAttributes([ ...voucherAttributes, ...voucherBags ])
  }

  return (
    <>
      <CardTextData
        label='Voucher Quantity'
        value={
          <Input
            type='number'
            name='quantity'
            placeholder='0'
            onChange={ handleInputChange }
          />
        }
      />

      <CardTextData
        label='Code Length'
        value={
          <Input
            type='number'
            name='codeLength'
            placeholder='0'
            onChange={ handleInputChange }
          />
        }
      />

      <CardTextData
        label='Code Format'
        value={
          <Input
            type='select'
            name='codeFormat'
            value={ voucher.codeFormat }
            onChange={ handleInputChange }
          >
            <option value={ 'alphanumeric' }>Alphanumeric</option>
            <option value={ 'alphabetical' }>Alphabetical</option>
            <option value={ 'numeric' }>Numeric</option>
          </Input>
        }
      />

      <CardTextData
        label='Code Prefix'
        value={
          <Input
            type='text'
            name='codePrefix'
            placeholder='insert the voucher code'
            onChange={ handleInputChange }
          />
        }
      />

      <CardTextData
        label='Code Suffix'
        value={
          <Input
            type='text'
            name='codeSuffix'
            placeholder='insert the voucher code'
            onChange={ handleInputChange }
          />
        }
      />

      <CardTextData
        label='Dash Every X Character'
        value={
          <Input
            type='number'
            name='dashCount'
            placeholder='0'
            onChange={ handleInputChange }
          />
        }
      />

      <CardTextData
        label='Use Per Customer'
        value={
          <Input
            type='number'
            name='usePerCustomer'
            placeholder='0'
            onChange={ handleInputChange }
          />
        }
      />

      <CardTextData
        label='Usage Limit'
        value={
          <Input
            type='number'
            name='usageLimit'
            placeholder='0'
            onChange={ handleInputChange }
          />
        }
      />

      <div className='float-right mb-3'>
        <Button
          color='primary'
          onClick={ () => generateVoucherCode() }
        >
          Add
        </Button>
      </div>
    </>
  )
}

VoucherGenerateCodeFields.propTypes    = propTypes
VoucherGenerateCodeFields.defaultProps = defaultProps
export default VoucherGenerateCodeFields